import React from "react";
import SEO from "../components/SEO";
import { getBreadcrumbSchema } from "../utils/schema";
import "./Legal.css";

export const Privacy = () => {
  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Privacy Policy', url: '/privacy' }
  ]);

  return (
    <div className="legal-page">
      <SEO
        title="Privacy Policy | Brightson Accounting Limited"
        description="Privacy policy for Brightson Accounting Limited. Learn how we collect, use, and protect your personal information."
        canonical="/privacy"
        schema={breadcrumbSchema}
      />
      
      <section className="legal-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p className="legal-updated">Last updated: December 2025</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-text">
            <h2>1. Introduction</h2>
            <p>
              Brightson Accounting Limited ("we", "our", "us") is committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
              when you visit our website or use our services.
            </p>

            <h2>2. Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul>
              <li><strong>Personal Information:</strong> Name, email address, phone number, business details when you contact us or use our services</li>
              <li><strong>Financial Information:</strong> Tax returns, business accounts, and other financial documents you provide for accounting services</li>
              <li><strong>Technical Information:</strong> IP address, browser type, device information, and website usage data</li>
            </ul>

            <h2>3. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>Provide professional accounting and tax services</li>
              <li>Respond to your enquiries and communicate with you</li>
              <li>Comply with legal and regulatory obligations (HMRC, Companies House, etc.)</li>
              <li>Improve our website and services</li>
              <li>Send service updates and important notices</li>
            </ul>

            <h2>4. Data Protection & Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal 
              information against unauthorized access, alteration, disclosure, or destruction. All 
              financial data is stored securely and in compliance with UK data protection laws.
            </p>

            <h2>5. Data Retention</h2>
            <p>
              We retain your personal and financial information for as long as required by UK law. 
              For accounting records, this is typically 6 years from the end of the financial year. 
              Tax records are retained for at least 5 years after the 31st January submission deadline.
            </p>

            <h2>6. Your Rights</h2>
            <p>Under UK GDPR, you have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data (subject to legal retention requirements)</li>
              <li>Object to processing of your data</li>
              <li>Request data portability</li>
              <li>Withdraw consent (where applicable)</li>
            </ul>

            <h2>7. Third-Party Services</h2>
            <p>
              We may share your information with trusted third parties necessary for providing our 
              services, including cloud accounting software providers, HMRC, and Companies House. 
              We ensure all third parties comply with UK data protection laws.
            </p>

            <h2>8. Cookies</h2>
            <p>
              Our website uses essential cookies for functionality. We do not use tracking or 
              advertising cookies. For more information, see our Cookie Policy.
            </p>

            <h2>9. Professional Standards</h2>
            <p>
              As FCCA and MAAT qualified accountants, we adhere to strict professional confidentiality 
              requirements under ACCA and AAT codes of ethics. Your information is treated with the 
              highest level of professional confidentiality.
            </p>

            <h2>10. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be posted on this 
              page with an updated revision date.
            </p>

            <h2>11. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or wish to exercise your data 
              protection rights, please contact us:
            </p>
            <p>
              <strong>Email:</strong> <a href="mailto:info@brightsonaccounting.co.uk">info@brightsonaccounting.co.uk</a><br/>
              <strong>Registered Office:</strong> 71-75 Shelton Street, Covent Garden, London, United Kingdom, WC2H 9JQ<br/>
              <strong>Service area:</strong> Serving Wolverhampton and the West Midlands
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
